const LpImages = () => {
    return (
      <>
       <div
              className="bg_reqLP relative max-lg:hidden"
              style={{ zIndex: "-14" }}
            >
              <img
                className="absolute top-[52vh] -left-[10%] w-[350px]"
                src={require(`../svg/blob3-light-blue.png`)}
                alt="SVG as an image"
              />
              <img
                className="absolute top-[17vh] -right-72 min-xl:-right-[11vw] w-[700px] blob3-light-blue"
                src={require(`../svg/circle-glass.png`)}
                alt=""
              />
              <img
                className="absolute top-[7vh] right-[42%] w-[100px]"
                src={require(`../svg/circle-light-blue.png`)}
                alt=""
              />
            </div>
      </>
    );
  };
  export default LpImages;